import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { heroSlides } from '@/mocks/home';

const heroImages = [
  'https://readdy.ai/api/search-image?query=Dynamic%20sports%20stadium%20atmosphere%20with%20dramatic%20lighting%2C%20grand%20scale%2C%20professional%20sports%20photography%20style%2C%20deep%20shadows%20and%20bright%20highlights%2C%20epic%20cinematic%20composition%2C%20warm%20dark%20toned%20background%2C%20no%20people%20faces%20visible&width=1600&height=900&seq=hero-slide-1&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Grand%20basketball%20arena%20with%20dramatic%20spotlight%20illumination%2C%20dark%20moody%20atmosphere%2C%20professional%20sports%20venue%20photography%2C%20warm%20golden%20and%20deep%20red%20accents%2C%20epic%20scale%2C%20abstract%20sports%20energy&width=1600&height=900&seq=hero-slide-2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Futuristic%20esports%20arena%20with%20neon%20accent%20lighting%20and%20dramatic%20stage%20design%2C%20dark%20atmosphere%20with%20vibrant%20color%20highlights%2C%20grand%20scale%2C%20professional%20event%20venue%2C%20cinematic%20composition&width=1600&height=900&seq=hero-slide-3&orientation=landscape',
];

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative w-full h-[600px] md:h-[700px] overflow-hidden">
      {heroSlides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === current ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={heroImages[index]}
            alt={slide.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
        </div>
      ))}

      <div className="absolute bottom-1/4 left-0 right-0 z-10">
        <div className="w-full px-4 md:px-6">
          <div className="text-center">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 tracking-wide leading-tight">
              {heroSlides[current].title}
            </h1>
            <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto">
              {heroSlides[current].subtitle}
            </p>
            <div className="flex items-center justify-center gap-4 flex-wrap">
              <a
                href={heroSlides[current].ctaLink}
                className="px-8 py-3 bg-primary-500 text-white font-semibold rounded-md hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap text-sm md:text-base"
              >
                {heroSlides[current].ctaText}
              </a>
              <Link
                to={heroSlides[current].secondaryLink}
                className="px-8 py-3 border-2 border-white/40 text-white font-semibold rounded-md hover:border-white hover:bg-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap text-sm md:text-base"
              >
                {heroSlides[current].secondaryText}
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex items-center gap-2">
        {heroSlides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-2.5 h-2.5 rounded-full transition-all duration-300 cursor-pointer ${
              index === current
                ? 'bg-primary-500 w-8'
                : 'bg-white/50 hover:bg-white/80'
            }`}
            aria-label={`第${index + 1}张`}
          />
        ))}
      </div>
    </section>
  );
}